import { render, staticRenderFns } from "./AppSystemBar.vue?vue&type=template&id=84d33ef8&scoped=true"
import script from "./AppSystemBar.vue?vue&type=script&lang=js"
export * from "./AppSystemBar.vue?vue&type=script&lang=js"
import style0 from "./AppSystemBar.vue?vue&type=style&index=0&id=84d33ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d33ef8",
  null
  
)

export default component.exports